import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";

export const CustomModal = ({ title, children, buttons, handleClose }) => (
  <Modal
    show={true}
    onHide={handleClose}
    backdrop="static"
    keyboard={false}
    size="xl"
  >
    <Modal.Header closeButton>
      <Modal.Title className="d-flex">
        <span>{title}</span>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      {buttons.map((button, index) => (
        <Button key={index} variant={button.variant} onClick={button.action}>
          {button.text}
        </Button>
      ))}
    </Modal.Footer>
  </Modal>
);

CustomModal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  handleClose: PropTypes.func.isRequired,
};
